import React, { useEffect, useState } from "react";

import EquipmentList from "./EquipmentList";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import {
  getDeliveryCenterConfig,
  setDeliveryCenterConfig,
} from "../../../api/DeliveryCenter/deliveryCenter";
import { dispatchSnackBarMessage } from "../../../utils/snackbar";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../../modals/AnimatedModal";

export default function EquipmentListModal({ show, closeModal }) {
  const [configs, setConfigs] = useState(null);

  useEffect(() => {
    if (show) {
      loadConfig();
    }
  }, [show]);

  const loadConfig = async () => {
    try {
      const params = {
        config: "equipment_dispatch_control",
      };
      const { data } = await getDeliveryCenterConfig(params);
      setConfigs(data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleEquipmentiDispatchControl = async (event) => {
    try {
      const newCheckedValue = event.target.checked;

      const data = {
        config: {
          equipment_dispatch_control: newCheckedValue,
        },
      };

      await setDeliveryCenterConfig(data);
      setConfigs({ ...configs, equipment_dispatch_control: newCheckedValue });
    } catch (e) {
      dispatchSnackBarMessage(
        `allow-money-switch-error-${new Date()}`,
        "Erro ao mudar status de descontos por valor em Real",
        "error"
      );
    }
  };

  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="60%"
      maxWidth="1000px"
    >
      <ModalHeader title="Maquininhas" onClose={closeModal} />
      <ModalContent padding={0}>
        <Grid xs={12} sm={4} md={4}>
          <FormControlLabel
            control={
              <Switch
                checked={configs?.equipment_dispatch_control}
                onChange={handleEquipmentiDispatchControl}
              />
            }
            label="Ativar Controle de Maquininhas"
          />
        </Grid>
        <EquipmentList />
      </ModalContent>
    </AnimatedModal>
  );
}
